import React from 'react';

/**
 * ChatGPT-style streaming indicators (no branded loader).
 * @param {'waiting' | 'cursor'} variant — dots before first token, blinking cursor while text streams
 */
const TeamAssistantReplyAnimation = ({ variant = 'cursor' }) => {
  if (variant === 'waiting') {
    return (
      <span className="team-assistant-stream-wait" role="status" aria-live="polite" aria-label="Assistant is replying">
        <span className="team-assistant-stream-dot" />
        <span className="team-assistant-stream-dot" />
        <span className="team-assistant-stream-dot" />
      </span>
    );
  }

  return <span className="team-assistant-stream-cursor" aria-hidden />;
};

export default TeamAssistantReplyAnimation;
